import {NgModule} from '@angular/core';
import {RouteReuseStrategy, RouterModule, Routes} from '@angular/router';
import {AuthGuard, NoAuthGuard, RouteReuse} from '@atumverse/core-decorators';
import {FinfraPortalLayoutComponent} from '@atumverse/portal-app';
import {
  FinfraDashboardContainerComponent
} from './portal/dashboard/finfra-dashboard-container/finfra-dashboard-container.component';
import {WebAppLayoutComponent} from './web/web-app-layout/web-app-layout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/web',
    pathMatch: 'full',
  },
  {
    path: 'web',
    component: WebAppLayoutComponent,
    canActivate: [NoAuthGuard],
    loadChildren: () =>
      import('./web/web.module').then(m => m.WebModule),
  },
  {
    path: 'portal',
    component: FinfraPortalLayoutComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@atumverse/portal-app').then(m => m.FinfraPortalModule),
      },
      {
        path: 'studio',
        data: {
          reuse: false,
        },
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
          },
          {
            path: 'dashboard',
            data: {
              reuse: false,
            },
            component: FinfraDashboardContainerComponent,
          },
          {
            path: 'pages',
            data: {
              reuse: false,
            },
            loadChildren: () =>
              import('./finfra-studio/finfra-studio.module').then(m => m.FinfraStudioModule),
          },
        ],
      },
    ],
  },
  {path: '**', redirectTo: '/web', pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true, onSameUrlNavigation: 'reload'})],
  exports: [RouterModule],
  providers: [AuthGuard, NoAuthGuard, {provide: RouteReuseStrategy, useClass: RouteReuse}],
})
export class AppRoutingModule {
}
